/** Same source image may be re-encoded in the office scope, changing its byte
 * size and hash while retaining the original camera filename. Keep the saved
 * evidence in both scopes; collapse matching names only in the default view. */
export function uniqueOfficePhotos<T extends {name:string}>(office:T[],installer:T[]):T[]{
  const seen=new Set(installer.map(p=>p.name.toLowerCase()));
  return office.filter(p=>{const key=p.name.toLowerCase();if(seen.has(key))return false;seen.add(key);return true;});
}
